import { TemplateExtended } from '@distribute/shared/api-types/templates';

export const formatTemplateType = (template: TemplateExtended) => {
  return template.isSinglePage ? 'Single-tab' : 'Multi-tab';
};
